module.exports = __webpack_public_path__ + "img/slide-15.a6168726.png";